module.exports = __webpack_public_path__ + "media/images/title__bg-9f1da57f166ec7279a0f3766244be2c8.png";